import React from 'react';

import './RealPosts.scss';
import { useFetchLastThreePosts } from '../../../services/networking/fetch-hooks/useFetchLastThreePosts';

import { PostList } from '../../../components/lists/PostList';
import { SectionTitle } from '../../../components/SectionTitle/SectionTitle';

export function RealPosts() {
  const { posts, isLoading, hasError } = useFetchLastThreePosts();

  if (isLoading || hasError) {
    return null;
  }
  return (
    <div className='RealPosts'>
      <SectionTitle title='Last three posts' />
      <div className='RealPosts__posts-wrapper'></div>
      <PostList posts={ posts || [] } isLanding={ true } />
    </div>
  );
}
